import * as z from "zod";

const schema = z.object({
  NODE_ENV: z.enum(['development','test','production']),
  NEXT_PUBLIC_SUPABASE_URL: z.url(),
  NEXT_PUBLIC_SUPABASE_ANON_KEY: z.string().min(1),
})

const data = {
  NODE_ENV: process.env.NODE_ENV,
  NEXT_PUBLIC_SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL,
  NEXT_PUBLIC_SUPABASE_ANON_KEY: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
}

const parsed = schema.safeParse(data)
if (!parsed.success) {
  console.error('❌ Invalid/missing env:', z.treeifyError(parsed.error))
  process.exit(1)
}

const env = parsed.data
export default env